module.exports = __webpack_public_path__ + "static/media/discovery.f77bb249.png";